import { render, staticRenderFns } from "./TecResume.vue?vue&type=template&id=278c10af&"
import script from "./TecResume.vue?vue&type=script&lang=js&"
export * from "./TecResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports